import * as React from 'react';
import { config } from 'config';

import styles from './registration-form.module.css';

export const RegistrationForm: React.FC = () => {
    const ref = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (ref && ref.current) {
            const script1 = document.createElement('script');
            script1.type = 'text/javascript';
            script1.src = config.voyage.scriptSrc;
            script1.async = true;
            script1.onload = () => {
                const script2 = document.createElement('script');
                script2.type = 'text/javascript';
                script2.textContent = `hbspt.forms.create({region: "${config.voyage.region}",portalId: "${config.voyage.portalId}",formId: "${config.voyage.form.id}"});`;
                if (ref && ref.current) {
                    ref.current.appendChild(script2);
                }
            };
            ref.current.appendChild(script1);
        }
    }, []);

    return <div className={styles.formContainer} ref={ref}></div>;
};
